import {
  IBookableServiceListParams,
  ICreateBookableServicePayload,
  IUpdateBookableServicePayload
} from '@pharvio/core/shared';

export class LoadBookableServices {
  static readonly type = '[Bookable Services] Load Bookable Services';
  constructor(public params: IBookableServiceListParams = {}) {}
}

export class LoadBookableService {
  static readonly type = '[Bookable Services] Load Bookable Service';
  constructor(
    public id: string,
    /** Refetch even when the list already holds the row. */
    public reload = false
  ) {}
}

export class CreateBookableService {
  static readonly type = '[Bookable Services] Create Bookable Service';
  constructor(public payload: ICreateBookableServicePayload) {}
}

export class UpdateBookableService {
  static readonly type = '[Bookable Services] Update Bookable Service';
  constructor(
    public id: string,
    public payload: IUpdateBookableServicePayload
  ) {}
}

export class DeleteBookableService {
  static readonly type = '[Bookable Services] Delete Bookable Service';
  constructor(public id: string) {}
}

export class SelectBookableService {
  static readonly type = '[Bookable Services] Select Bookable Service';
  constructor(public id: string | null) {}
}
